import { createVanIconComponent } from "./van"

const BookmarkOutlined = createVanIconComponent("bookmark-o")
export default BookmarkOutlined
